module.exports = __webpack_public_path__ + "static/media/qr-img.d9695010.svg";